import { AccountRole } from '@football-kids/shared/enums';
import { Account } from '@football-kids/shared/entity/Account';
import { AppPermissions } from '../../types';


export const getRole = (permissions: Record<AccountRole, boolean>) => {
    if (permissions[AccountRole.ADMIN]) {
        return AccountRole.ADMIN;
    } else if (permissions[AccountRole.MANAGER]) {
        return AccountRole.MANAGER;
    } else if (permissions[AccountRole.COACH]) {
        return AccountRole.COACH;
    } else if (permissions[AccountRole.CHILD]) {
        return AccountRole.CHILD;
    }

    return AccountRole.PARENT;
};

export const toAppPermissions = (account: any | Account) => {

    return {
        [AccountRole.MANAGER]: account.role === AccountRole.MANAGER,
        [AccountRole.COACH]: account.role === AccountRole.COACH,
        [AccountRole.PARENT]: account.role === AccountRole.PARENT,
        [AccountRole.ADMIN]: account.role === AccountRole.ADMIN
    };
};


export const canAccess = (permissions: AppPermissions, validRoles: AccountRole | AccountRole[]) => {
    const accountRole = getRole(permissions);

    if (Array.isArray(validRoles)) {
        if (validRoles.includes(accountRole)) {
            return true;
        }
    } else {
        if (validRoles === accountRole) {
            return true;
        }
    }

    return false;
};
